import React from 'react';

export const Contacts = () => (
  <div className="c-footer__contact">
    <div className="o-grid">
      <div className="o-grid__col-sm-4">
        <div className="o-content">
          <div className="o-content__body">
            <h4>Location</h4>
            <address>Remote</address>
          </div>
        </div>
      </div>

      <div className="o-grid__col-sm-4">
        <div className="o-content">
          <div className="o-content__body">
            <h4>Contact</h4>
            <p>
              <span className="t-link-container__item--blended">
                <a href="https://goo.gl/forms/P59EGXlPEUKefnl22" name="External link to the contact form" target="_blank" rel="noopener noreferrer">
                  Open form
                </a>
              </span>
            </p>
          </div>
        </div>
      </div>

      <div className="o-grid__col-sm-4">
        <div className="o-content">
          <div className="o-content__body">
            <h4>Download</h4>
            <p>
              <span className="t-link-container__item--blended">
                <a href="https://docs.google.com/document/d/1kAo4eqt2flmlpZfwsuZR9XR4VEhkYnSrBubW8zjxmcc/export?format=pdf" name="Download Michele Di Salvatore CV">
                  CV.pdf
                </a>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Contacts/Contacts.js